import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Btn } from "@/components/kit";
import { track } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PayDialog({ tier, onClose }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  if (!tier) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      toast.error("Please add your name and email.");
      return;
    }
    setLoading(true);
    try {
      track("begin_checkout", { tier: tier.id, value: tier.amount, currency: "AUD" });
      const { data } = await axios.post(`${API}/payments/checkout`, {
        tier_id: tier.id,
        origin_url: window.location.origin,
        name: name.trim(),
        email: email.trim(),
        phone: phone.trim(),
      });
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        toast.error("Could not start checkout. Please try again.");
        setLoading(false);
      }
    } catch (err) {
      toast.error("Something went wrong starting the payment.");
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-end md:items-center justify-center p-0 md:p-6"
      role="dialog"
      aria-modal="true"
      data-testid="pay-dialog"
    >
      <button aria-label="Close" className="absolute inset-0 bg-[#151412]/60" onClick={onClose} data-testid="pay-dialog-overlay" />
      <div className="relative w-full md:max-w-md bg-[var(--paper)] border border-[var(--stone)] rounded-t-[2px] md:rounded-[2px] p-8 md:p-10">
        <p className="eyebrow">Secure payment via Stripe</p>
        <h3 className="t-h3 mt-3">{tier.label}</h3>
        <p className="t-sm text-[var(--muted)] mt-1">AUD ${tier.amount.toLocaleString()} inc GST</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="t-caption font-mono uppercase tracking-wide text-[var(--muted)]" htmlFor="pd-name">Your name</label>
            <input id="pd-name" className="field mt-2" value={name} onChange={(e) => setName(e.target.value)} data-testid="pay-name" autoComplete="name" />
          </div>
          <div>
            <label className="t-caption font-mono uppercase tracking-wide text-[var(--muted)]" htmlFor="pd-email">Email</label>
            <input id="pd-email" type="email" className="field mt-2" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="pay-email" autoComplete="email" />
          </div>
          <div>
            <label className="t-caption font-mono uppercase tracking-wide text-[var(--muted)]" htmlFor="pd-phone">Phone (optional, for your reminder)</label>
            <input id="pd-phone" type="tel" className="field mt-2" placeholder="+61…" value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="pay-phone" autoComplete="tel" />
          </div>
          <div className="flex items-center gap-3 pt-2">
            <Btn type="submit" variant="clay" className="flex-1 justify-center" data-testid="pay-submit">
              {loading ? "Redirecting\u2026" : "Continue to payment"}
            </Btn>
            <Btn variant="outline" onClick={onClose} data-testid="pay-cancel">Cancel</Btn>
          </div>
          <p className="t-caption text-[var(--muted)] pt-1">
            You will be sent the scheduling link and a short pre-work request as soon as payment is confirmed.
          </p>
        </form>
      </div>
    </div>
  );
}
